import ReactHook from "./ReactHook";
import GLCanvas from "./GLCanvas";
function hookupCanvas(div, props, controller) {
    ReactHook.hookup(div, GLCanvas, Object.assign(Object.assign({}, props), { controller }), controller);
}
const exports = {
    hookupCanvas,
    GLCanvas,
};
export default exports;
globalThis.exports = exports;
